import PropTypes from "prop-types";
import { useSecurity } from "~/components/Hooks/useSecurity";
import { allowedArguments } from "~/security";

export const Can = ({ I, entity, context, not, children }) => {
  const can = useSecurity();

  if (not) {
    return entity && !can([I], entity, context) ? children : null;
  }
  return entity && can([I], entity, context) ? children : null;
};

Can.propTypes = {
  I: PropTypes.oneOf(allowedArguments).isRequired,
  entity: PropTypes.object.isRequired,
  not: PropTypes.bool,
  context: PropTypes.object,
  children: PropTypes.node,
};
